import React, { useState } from "react";
import { Button } from "../../../design-system/components/primitives/Button/Button";
import { SHARE_ACTIONS_COPY as C } from "./ShareLinkActions.copy";
import { Hint, Row, Wrap } from "./ShareLinkActions.styles";

export interface ShareLinkActionsProps {
  /** Stops the link working now (access back to restricted). */
  onRevoke: () => void;
  /** Makes a new link and kills the old one. */
  onReset?: () => void;
  disabled?: boolean;
  /** Why the actions are disabled; shown as a hint and tooltip. */
  disabledReason?: string;
  className?: string;
}

/** Revoke and Reset as two separate, confirmed actions with the one-line difference. */
export const ShareLinkActions: React.FC<ShareLinkActionsProps> = ({ onRevoke, onReset, disabled = false, disabledReason, className }) => {
  const [pending, setPending] = useState<"revoke" | "reset" | null>(null);
  const confirm = () => {
    const which = pending;
    setPending(null);
    if (which === "revoke") onRevoke();
    else if (which === "reset") onReset?.();
  };
  return (
    <Wrap className={className}>
      <Row>
        <Button variant="outline" size="sm" disabled={disabled} title={disabled ? disabledReason : undefined} onClick={() => setPending("revoke")}>{C.revoke}</Button>
        {onReset ? (
          <Button variant="outline" size="sm" disabled={disabled} title={disabled ? disabledReason : undefined} onClick={() => setPending("reset")}>{C.reset}</Button>
        ) : null}
      </Row>
      <Hint>{disabled && disabledReason ? disabledReason : C.hint}</Hint>
      {pending ? (
        <Row role="alertdialog" aria-label={pending === "revoke" ? C.revoke : C.reset}>
          <Hint as="span">{pending === "revoke" ? C.revokeConfirm : C.resetConfirm}</Hint>
          <Button variant="primary" size="sm" onClick={confirm}>{pending === "revoke" ? C.revokeYes : C.resetYes}</Button>
          <Button variant="outline" size="sm" onClick={() => setPending(null)}>{C.cancel}</Button>
        </Row>
      ) : null}
    </Wrap>
  );
};

export default ShareLinkActions;
